import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  InformationScreenProperties,
  InformationScreenComponent,
} from '@app/shared/common/components/information-screen/information-screen';
import { ScreenShareOffIcon } from 'lucide-angular';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, ConfirmDialogModule, Toast, InformationScreenComponent],
  templateUrl: './app.html',
})
export class App {
  protected readonly responsiveScreenInformation: InformationScreenProperties = {
    details: { icon: ScreenShareOffIcon, summary: 'Resolution not supported' },
    message:
      'Your screen resolution is too low to use Comex web application.<br/> Please switch to a larger device or resize the browser window.',
  };
}
